module.exports = __webpack_public_path__ + "components/country-flag/static/ir-8477338b9dbb4760be3ee34d9d7be450.svg";